/*
 * Copyright 2026 North Carolina State University
 */

import React from 'react';
import '../../styles/Navbar.css';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { ModuleGate } from '../../modules/registry';

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/signin', { replace: true });
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  const isActive = (path) => {
    if (path === '/projects') {
      return location.pathname.startsWith('/projects') ? 'active' : '';
    }
    return location.pathname === path ? 'active' : '';
  };

  return (
    <nav className="navbar">
      <div className="menu-section">
        <span className="menu-label">USER MENU:</span>
        <ul className="nav-links">
          <li className={isActive('/')}>
            <Link to="/">Home</Link>
          </li>
          <li className={isActive('/projects')}>
            <Link to="/projects">Applications</Link>
          </li>
          <li className={isActive('/profile')}>
            <Link to="/profile">Profile</Link>
          </li>
          <li>
            <button onClick={handleLogout}>Log Out</button>
          </li>
        </ul>
      </div>

      {user && user.institution_roles?.some(r => r.role === 'Admin') && (
        <div className="menu-section">
          <span className="menu-label">ADMIN MENU:</span>
          <ul className="nav-links">
            <li className={isActive('/admin/application')}>
              <Link to="/admin/application">Applications</Link>
            </li>
            <li className={isActive('/admin/requests')}>
              <Link to="/admin/requests">Requests</Link>
            </li>
            <li className={isActive('/admin/accounting')}>
              <Link to="/admin/accounting">Accounting</Link>
            </li>
            <li className={isActive('/admin/reporting')}>
              <Link to="/admin/reporting">Reporting</Link>
            </li>
            <li className={isActive('/admin/chats')}>
              <Link to="/admin/chats">Chats</Link>
            </li>
            <li className={isActive('/admin/manage-program-data')}>
              <Link to="/admin/manage-program-data">Manage Program Data</Link>
            </li>
            <ModuleGate module="ipm">
              <li className={isActive('/admin/ipm')}>
                <Link to="/admin/ipm">IPM</Link>
              </li>
            </ModuleGate>
          </ul>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
